<template>
  <span class="bg-gray-100 p-1 rounded-xl">
    <!-- <XButton
      class="p-1 mr-2 w-6 h-6 bg-red-200 rounded-lg"
      @click="deleteOption(data)"
      v-if="canChange && canDelete"
    />{{ data }} -->
    <Button
      class="p-1 mr-2 w-6 h-6 bg-red-200 rounded-lg text-lg"
      v-if="canChange && canDelete"
      @click="deleteOption">
      <svg
        class="w-4 h-4"
        fill="#000000"
        viewBox="0 0 256 256"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M216,140H40a12,12,0,0,1,0-24H216a12,12,0,0,1,0,24Z"/>
      </svg>
    </Button>
    {{ displayText }}
  </span>
</template>

<script>
import Button from '../../Button.vue'

import buildingData from '../../../services/viewData/building.js'
import districtData from '../../../services/viewData/district.js'
import partitionData from '../../../services/viewData/partition.js'
import schoolYearData from '../../../services/viewData/schoolYear.js'
import vendorData from '../../../services/viewData/vendor.js'

import notifications from '../../../services/notifications.js'

import DROPDOWN_LISTS from '../../../components/DropdownLists.json'

const DATA_TYPE_MAP = {
  schoolYear: schoolYearData,
  partition: partitionData,
  district: districtData,
  vendor: vendorData,
  building: buildingData,
}

const DISPLAY_FUNC_MAP = {
  schoolYear: value => DROPDOWN_LISTS.schoolYears[value.code],
  partition: value => value.data.description,
  district: value => `${value.id} -- ${value.data.name}`,
  vendor: function (value) {
    let _partition = partitionData.getSync(value.depends.partition)
    return `${value.data.name} -- ${_partition.data.description}`
  },
  building: value => value.data.name,
}

const DISPLAY_TYPE_NAME = {
  schoolYear: 'School Year',
  partition: 'State/Partition',
  district: 'District',
  vendor: 'Vendor',
  building: 'Building',
}

export default {
  components: {
    Button,
  },
  props: {
    id: [String, Number],
    type: String,
    canChange: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayText: undefined,
      dataPromise: undefined,
    }
  },
  methods: {
    prepareTextData() {
      if (this.dataPromise === undefined) {
        this.displayText = `Loading (${this.id})`
      }
      let dataModule = DATA_TYPE_MAP[this.type]
      this.dataPromise = dataModule.get(this.id)

      this.dataPromise.then(item => {
        if (item === undefined) {
          notifications.pushError(`User data view has invalid setting in type "${DISPLAY_TYPE_NAME[this.type]}" with value: "${this.id}"`)
          return
        }
        this.displayText = DISPLAY_FUNC_MAP[this.type](item)
      })
    },
    deleteOption() {
      this.$emit('deleteOption', this.id)
    },
  },
  mounted() {
    this.prepareTextData()
  },
  watch: {
    id() {
      this.prepareTextData()
    },
    type() {
      this.prepareTextData()
    },
  },
}
</script>
